import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const outerContainerStyles: BoxStyleProps = {
    display: "flex",
    flexDirection: "column",
    marginBottom: "space40"
};

export const bubbleAndAvatarContainerStyles: BoxStyleProps = {
    display: "flex",
    alignItems: "flex-end"
};

export const getAvatarContainerStyles = (placeholder: boolean): BoxStyleProps => ({
    width: "sizeIcon40",
    height: "sizeIcon40",
    marginRight: "space30",
    borderRadius: "borderRadiusCircle",
    overflow: "hidden",
    flex: "0 0 auto",
    backgroundColor: placeholder ? "transparent" : "colorBackground"
});

export const getInnerContainerStyles = (belongToCurrentUser: boolean) => ({
    padding: "0.5rem 0.75rem",
    backgroundColor: belongToCurrentUser ? "#F4F4F6" : "#FFE2EE",
    borderRadius: "8px",
    marginLeft: belongToCurrentUser ? "auto" : "0px",
    marginRight: belongToCurrentUser ? "0px" : "auto",
    maxWidth: "90%"
});

export const authorStyles: TextStyleProps = {
    color: "inherit",
    fontWeight: "fontWeightBold",
    fontSize: "fontSize20",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis", // doesn't get applied for some reason – need to investigate
    overflow: "hidden"
};

export const timeStampStyles: TextStyleProps = {
    fontSize: "fontSize20",
    marginLeft: "space40",
    color: "inherit"
};

export const bodyStyles: TextStyleProps = {
    color: "inherit",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
};

export const readStatusStyles: TextStyleProps = {
    textAlign: "right",
    fontSize: "fontSize10",
    marginRight: "space20",
    color: "colorText"
};
//eslint-disable-next-line
export const bubbleButtonStyle = {
    backgroundColor: "#FF5995",
    boxShadow: "rgb(3, 11, 93)",
    width: "auto",
    display: "inline-block",
    border: "none",
    outline: "none",
    transition: "background-color 100ms ease-in 0s, box-shadow 100ms ease-in 0s, color 100ms ease-in 0s",
    fontWeight: "600",
    textDecoration: "none",
    margin: "0px",
    cursor: "pointer",
    color: "white",
    padding: "0.5rem 0.75rem",
    borderRadius: "4px",
    fontSize: "0.875rem",
    lineHeight: "1.25rem"
};
